import React, { useEffect, useMemo } from 'react';
import { MapContainer, TileLayer, GeoJSON, useMap } from 'react-leaflet';
import L from 'leaflet';
import { MapIcon } from '@heroicons/react/24/outline';
import 'leaflet/dist/leaflet.css';

function FitBoundsToRoutes({ routes }) {
  const map = useMap();

  useEffect(() => {
    if (!routes || routes.length === 0) return;

    const bounds = L.latLngBounds([]);
    for (const route of routes) {
      if (!route?.geom) continue;
      const layer = L.geoJSON(route.geom);
      bounds.extend(layer.getBounds());
    }

    if (bounds.isValid()) {
      map.fitBounds(bounds, { padding: [24, 24] });
    }

    // Helps Leaflet recalc size inside flex layouts.
    map.invalidateSize();
  }, [routes, map]);

  return null;
}

export default function DashboardRoutesMap({ routes, className = '' }) {
  const routesWithGeom = useMemo(() => {
    return (routes || []).filter((r) => r?.geom);
  }, [routes]);

  return (
    <div
      className={`box-border w-full min-h-[476px] bg-[#FDFEFF] rounded-[16px] p-[24px] flex flex-col ${className}`.trim()}
    >
      <div className="w-full flex items-center gap-[4px]">
        <div className="text-[16px] font-light leading-[155%] text-[#333333]">Routes Map</div>
        <MapIcon className="w-[18px] h-[18px] text-[#333333]" aria-hidden="true" />
      </div>

      <div className="mt-[16px] w-full flex-1 min-h-0 rounded-[8px] overflow-hidden">
        <MapContainer
          center={[37.9838, 23.7275]}
          zoom={12}
          style={{ width: '100%', height: '100%' }}
          scrollWheelZoom={true}
        >
          <TileLayer
            url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution="&copy; OpenStreetMap contributors"
          />

          {routesWithGeom.length > 0 && (
            <>
              <FitBoundsToRoutes routes={routesWithGeom} />
              {routesWithGeom.map((route) => (
                <GeoJSON
                  key={route.id ?? JSON.stringify(route.geom)}
                  data={route.geom}
                  style={{
                    color: '#B75DF3',
                    weight: 4,
                    opacity: 0.8,
                    lineCap: 'round',
                    lineJoin: 'round',
                  }}
                />
              ))}
            </>
          )}
        </MapContainer>
      </div>
    </div>
  );
}
